export const socialsMaxCount = 6
export const socialsMinCount = 0
